import { Box } from "@mui/material"
import { CustomePanel, CustomeTab } from "../../../../components/customeTab"
import { useLogbookContext } from "./context"
import { TabsItem } from "./utils"
import { ActivityRegister } from "./components"
import { Access } from "./components/access"
import { ActivitiesCatalog } from "./components/catalog"
import { MyActivity } from "./components/myActivity"
import { useEffect, useMemo } from "react"
import { ActionTabs } from "./components/shared/actionsTabs"
import { useLocation, useNavigate } from "react-router-dom"
import { Hashs } from "./components/activityRegister/utils"
import { DailyCuts } from "./components/dailyCuts"
import { BreadCrumb } from "../../../../components"
import { DestinationsRegistered } from "./components/destinationRegistered"

export const Main = () => {
    const location = useLocation()
    const navigate = useNavigate()

    const hash = location.hash
    const existHash = [Hashs.DETAIL, Hashs.CREATE, Hashs.EDIT].some((h) => hash.includes(h))

    const { listTab, state, changeTab, service, scheduleMeta } = useLogbookContext()

    useEffect(() => {
        if (!existHash) {
            service.getAreaItem()
            service.getDepartmentItem()
            service.getStoreItem()
            service.getRoleItem()
            service.getDivisionItem()
            service.getUserTypeItem()
            service.getStatusItem()
            service.getUsersItem()
            service.datesItems()
        }
    }, [existHash, location.hash])

    const breadList = useMemo(() => {
        const meta: any = scheduleMeta
        if (!meta?.origin) return []

        const isUnit = meta.origin === "UNIT"

        const backPath = isUnit
            ? `/dashboard/calendar/detail/${meta.scheduleId ?? meta.assignedQuestionnaireIds}`
            : `/dashboard/schedule-user/detail/${meta.scheduleId ?? meta.userQuestionnaireIds}`


        const assignedQuestionnaireId =
            isUnit
                ? Number(String(meta.assignedQuestionnaireIds ?? "").split(",")[0] || 0)
                : undefined

        return [
            {
                id: "scheduleMeta",
                label: isUnit ? "scheduleByUnit" : "sheduleByUser",
                labelParams: { name: meta.questionnaireName ?? "" },
                active: false,
                path: backPath,
                navigate: () => {
                    if (isUnit) {
                        navigate(backPath, { state: { assignedQuestionnaireId } })
                        return
                    }
                    navigate(backPath)
                },
            },
            {
                id: "logbook",
                label: "logbook",
                active: true,
                path: "/dashboard/logbook",
                navigate: () => { },
            },
        ]
    }, [scheduleMeta, navigate])


    return (
        <Box className="main-container">
            <BreadCrumb notAddPath breadList={breadList as any} />

            <Box>
                <CustomeTab
                    listTab={listTab}
                    value={state.tab}
                    justifyContent="start"
                    endChildrenTab={!existHash ? <ActionTabs tab={state.tab} /> : undefined}
                    tabList={{
                        onChange: (_, value) => changeTab({ value }),
                    }}
                >
                    <CustomePanel value={TabsItem.ACTIVITY_REGISTER}>
                        <ActivityRegister />
                    </CustomePanel>
                    <CustomePanel value={TabsItem.MY_ACTIVITY}>
                        <MyActivity />
                    </CustomePanel>
                    <CustomePanel value={TabsItem.DAILYCUTS}>
                        <DailyCuts />
                    </CustomePanel>
                    <CustomePanel value={TabsItem.ACCESS}>
                        <Access />
                    </CustomePanel>
                    <CustomePanel value={TabsItem.CATALOG}>
                        <ActivitiesCatalog />
                    </CustomePanel>
                    <CustomePanel value={TabsItem.DESTINATION_REGISTERED}>
                        <DestinationsRegistered />
                    </CustomePanel>
                </CustomeTab>
            </Box>
        </Box>
    )
}
